module.exports = __webpack_public_path__ + "img/STS_Logo_Final.011bd4d3.png";